import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Fade from "react-reveal/Fade";

function AcademyTrade () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative flex flex-col xl:flex-row gap-[32px]">
                <Fade bottom><div className="bg-[#CEDFF2] h-[238px] w-full rounded-[15px] flex flex-col justify-center items-center relative">
                    <p className="font-[700] open-sans text-[17px] xl:text-[19px] text-[#0C2780]">{t('home.50')}</p>
                    <p className="xl:max-w-[473px] open-sans text-[#0C2780] font-[300] mt-[15px] text-center px-[10px] xl:px-0">{t('home.51')}</p>
                    <a href="###" className="mt-[40px]">
                        <div className="button_main flex cursor-pointer rounded-[5px] hover:scale-[1.1] transition-all bg-[#0C2780]">
                            <p className="open-sans font-[400] text-[18px] text-[#EFEFEF]">{t('home.54')}</p>
                        </div>
                    </a>
                </div></Fade>
                <Fade bottom><div className="bg-[#FFFFFF] h-[238px] w-full rounded-[15px] flex flex-col justify-center items-center relative">
                    <p className="font-[700] open-sans text-[17px] xl:text-[19px] text-[#0C2780]">{t('home.52')}</p>
                    <p className="xl:max-w-[473px] open-sans text-[#0C2780] font-[300] mt-[15px] text-center px-[10px] xl:px-0">{t('home.53')}</p>
                    <a href="###" className="mt-[20px]">
                        <div className="button_main flex cursor-pointer rounded-[5px] hover:scale-[1.1] transition-all bg-[#0C2780]">
                            <p className="open-sans font-[400] text-[18px] text-[#EFEFEF]">{t('home.54')}</p>
                        </div>
                    </a>
                </div></Fade>
            </div>
        </div>
    );
}

export default AcademyTrade;